class DZModelNormalUser {

    id = "";

    name = '';
    /**
     * 手机号
     */
    phone = "";

    /**
     * 头像图片ID
     */
    headerId = "";

    /**
     * 邮箱
     */
    email = "";

    /**
     * 微信号
     */
    wxNum = "";

    /**
     * 地址ID
     */
    address = "";

    /**
     * 审核状态：99-正常，-1-禁用
     */
    status = "";

    password = ""
    password2 = ""
}
export default DZModelNormalUser;
